import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/layout/header.jsx";
import LeftMenu from "../../../components/layout/leftMenu.jsx";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { backendApi } from "../../../api/apiService.js";
import { ToastContainer, toast } from "react-toastify";
import { ShimmerContentBlock } from "react-shimmer-effects";
import { FaMapPin, FaRupeeSign, FaShoppingBag, FaAward } from "react-icons/fa";
import { MdOutlineDescription } from "react-icons/md";
import { BsCalendar2Date } from "react-icons/bs";
import { FcHighPriority } from "react-icons/fc";
import { useLocation } from "react-router-dom";
import noData from "../../../images/noData.png";
import { FiSearch } from "react-icons/fi";
function JobOpeningHistory() {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("loc", location.state);
  const [openings, setOpenings] = useState([]);
  const [loader, setloader] = useState(false)
  const [searchTerm, setSearchTerm] = useState("");
  const [originalOpenings, setOriginalOpenings] = useState([]);
  useEffect(() => {
    // setOpenings(location.state.props);
    openingHistory();
    setTimeout(() => {
      document.getElementById("NewVacancyMenu").classList.add("active");
    }, 500);
  }, []);

  const openingHistory = () => {
    var req = {
      functionName: "job_opening_Listing_byUser",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        setOpenings(response.skill || []);
        setOriginalOpenings(response.skill || []);
        setloader(true)
      } else {
        console.log("error in api");
        return false;
      }
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const viewResumes = (value) => {
    const yourProp = value;
    navigate(`/viewMatching`, {
      state: {
        props: yourProp,
      },
    });
  };

  const viewJD = (value) => {
    console.log(value);
    navigate(`/process`, {
      state: {
        props: value.id,
        from: 'jobhistory'
      },
    });
  };

  const goBack = () => {
    navigate(-1);
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  const handleSearch = () => {
    if (searchTerm.trim() === "") {
      setOpenings(originalOpenings);
    } else {
      const filtered = originalOpenings.filter(job =>
        job.summary.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setOpenings(filtered);
    }
  };

  return (
    <>
      {!loader ? <ShimmerContentBlock title text cta thumbnailWidth={370} thumbnailHeight={370} />
        :
        <div className="xilliRight">
          <div className="xilliWrap">
            <>

              <div className="row mt-5 justify-content-center">




                <div className="col-md-7">
                  <div className="d-flex align-items-center  gap-2 mb-3">
                    <div className="w-100">
                      <div className="input-group">
                        <span className="input-group-text text-body search_group_text">
                          <FiSearch />
                        </span>
                        <input
                          type="text"
                          className="form-control search_input border"
                          placeholder="Enter Positions"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button
                          className="btn btn-search-custome"
                          onClick={handleSearch}
                        >
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {openings?.length > 0 ? (
                  <div className="col-md-7">


                    {openings.map((candidate, index) => {
                      console.log(
                        "🚀 ~ file: openingsListing.jsx:116 ~ {openings.map ~ candidate:",
                        candidate
                      );
                      return (
                        <div className="crnRes">
                          <div className="row">
                            <div className="col-md-11">
                              <h4 className="mb-2">
                                {candidate.summary.replace(/\\(['"])/g, "$1")}
                              </h4>
                              <p className="mb-1">
                                <span>
                                  <MdOutlineDescription title="description" />{" "}
                                  {candidate.description.replace(
                                    /\\(['"])/g,
                                    "$1"
                                  )}{" "}
                                </span>
                              </p>
                              <p>
                                <span>
                                  <BsCalendar2Date title="Start Date" />{" "}
                                  {formatDate(candidate.start_date)}{" "}
                                </span>
                                |
                                <span>
                                  Status :{" "}
                                  {candidate.status
                                    ? candidate.status
                                    : " Not Available"}{" "}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className="row crmExp">
                            <div className="col-md-8">
                              <div className="">
                                <p className="mb-1">
                                  <span>
                                    <FaShoppingBag title="experience" />{" "}
                                    {candidate.experiance
                                      ? candidate.experiance
                                      : 0}{" "}
                                    Years{" "}
                                  </span>
                                  |
                                  <span>
                                    {" "}
                                    CTC : <FaRupeeSign />{" "}
                                    {candidate.salary ? candidate.salary : 0}
                                  </span>
                                  |
                                  <span>
                                    {" "}
                                    Job Type :{" "}
                                    {candidate.job_type ? candidate.job_type : 0}
                                  </span>
                                </p>
                                <p>
                                  <span>
                                    <FcHighPriority title="priority" />{" "}
                                    {candidate.priority ? candidate.priority : 0}
                                    {"  "}
                                  </span>
                                  |
                                  <FaMapPin title="Location" />{" "}
                                  {candidate.location
                                    ? candidate.location
                                    : "Not Available"}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="crmPost">
                            <div className="row">
                              <div className="col-md-5">
                                {/* <p> */}
                                <p>
                                  Posted on : {formatDate(candidate.created_on)}
                                </p>
                                {/* | */}
                                <p>
                                  No of Positions :{" "}
                                  {candidate.no_of_position
                                    ? candidate.no_of_position
                                    : 0}{" "}
                                </p>
                                {/* </p> */}
                              </div>
                              <div className="col-md-5 text-end">
                                <button
                                  className="btn btn-btn1 btn-btn bg-secondary mb-3"
                                  s
                                  onClick={() => viewResumes(candidate)}
                                >
                                  View matching Resumes
                                </button>
                              </div>
                              <div className="col-md-2">
                                <button
                                  className="btn btn-btn1 btn-btn bg-primary w-100 mb-3"
                                  onClick={() => viewJD(candidate)}
                                >
                                  JD
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  </div>
                ) : (
                  <div className="noHistory d-flex flex-column">
                    <div>
                      <img src={noData} alt="noData" />
                    </div>
                    <div>No History Available</div>
                  </div>
                )}
              </div>

            </>
          </div>
        </div>
      }
    </>
  );
}

export default JobOpeningHistory;
